export default __webpack_public_path__ + "5c91087.png";